module.exports = __webpack_public_path__ + "img/img_half_wide.73479419.png";